import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useLocalStorage, useDebounce } from 'react-use';
import {
  Card,
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import FileUpload from 'components/FileUpload/FileUpload.js';
import useNotif from 'hooks/use-notify-hook';
import AnswerRepository from 'repository/Answer.js';

function Formula ({answer, scores, isReadonly, children}) {

  const [score, setScore] = useState('n/a');
  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  const [evaluation, setEvaluation] = useState(answer?.EVALUATE_DESC ?? ``);
  const [attachments, setAttachments] = useState(answer?.answerAttachments ?? []);

  const repository = new AnswerRepository(auth.token);

  let filePromises = [];

  const handleUpload = async (file) => {

    try {
      filePromises.push(repository.upload(answer.ANSWER_ID, file));
      const promises = await Promise.all(filePromises);
      // setAttachments([...attachments, ...promises.map(item => item.data)]);
      promises.map(item => attachments.push(item.data));
      dispatchNotif({
        place: `br`,
        message: `Upload Success...`,
        type: `success`,
      });

      filePromises = [];

    } catch(ex) {

      dispatchNotif({
        place: `br`,
        message: `Upload Failed ${ex.toString()}`,
        type: `danger`,
      });

    }
  }

  const calculateScore = async () => {

    switch (true) {

      case answer.INDEX_ID !== null:
        let filteredScore = scores.find(item => item.INDEX_ID === answer.INDEX_ID);
        if (filteredScore) {
          await { then() {
            setScore(filteredScore.SCORE_INDEX);
          }}
        }
        break;

      case answer.question.FORMULA !== null:
        window.formula[answer.question.QUESTION_ID] = parseInt(answer.ANSWER_DESC);
        let formulatedScore = eval(answer.question.FORMULA);
        if (formulatedScore && scores.find(item => item.INDEX_ID === formulatedScore)) {
          const idx = scores.find(item => item.INDEX_ID === formulatedScore);
          const response = repository.answer(answer.ANSWER_ID, {INDEX_ID: idx.INDEX_ID});
          return setScore(idx.SCORE_INDEX);
        }
        break;

      default:
        console.log('none of the above')
    }
  }

  const [, cancelEvaluation] = useDebounce(async () => {

    const data = {
      EVALUATE_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
      EVALUATE_BY: auth.employee.EMP_ID,
      EVALUATE_DESC: evaluation,
    };

    const response = await repository.answer(answer.ANSWER_ID, data);

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

  }, 2000, [evaluation]);

  useEffect(() => {
    cancelEvaluation();
  }, []);

  useEffect(() => {
    if (scores) {
      calculateScore();
    }
  }, [scores]);

  return (
    <Row>
      {notif}
      <Col md="12">
        <Card>
          <Card.Header>
            <Card.Title as="h4"><a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
            <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="10">
                <Form.Group>
                  <Form.Label>Auditee's Answer</Form.Label>
                  <p>{answer.ANSWER_DESC}</p>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Evaluation</Form.Label>
                  <Form.Control
                    value={evaluation}
                    onChange={({ target: {value }}) => setEvaluation(value)}
                    as="textarea"
                    rows={3}
                    disabled={isReadonly}
                  />
                </Form.Group>
              </Col>
              <Col md="2">
                <Form.Group>
                  {attachments
                    ? attachments.map((attachment, key) => (
                        <div key={key} className="font-icon-detail">
                          <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`}>{attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}</a>
                        </div>
                    ))
                    : <p>No attachment uploaded.</p>
                  }
                  <FileUpload
                      onFileSelectSuccess={(file) => handleUpload(file)}
                      onFileSelectError={({ error }) => alert(error)}
                    >
                      Upload
                    </FileUpload>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Score</Form.Label>
                  <p>{score}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                {children}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default Formula;